import {
    doppeActionTypeContactForm
} from '../../doppe-action-types/doppe-action-type-contact-form/doppe-action-type-contact-form';
import {
    bymoListLayoutGetDefault,
    BymoPageProps,
    BymoPagePropsCommonPropsMetadata,
    BymoPagePropsForViewer,
    bymoPagePropsResolveAllActions,
    bymoPagePropsResolveFromPartialProps,
    bymoPagePropsResolvePageActions,
    BymoTemplateLayout,
    bymoTemplateLayoutGetDefault,
    bymoTemplateLayoutIsPremium,
    bymoTemplateListLayoutIsPremium,
    PartialBymoPageProps
} from '../bymo-pages/bymo-page-props';
import {WixImageResource, wixImageResourceGetUrl, wixMediaResourceIsWixImageResource} from '@wix/devzai-common-wix';
import {
    DoppeDtoInnerPage,
    DoppeDtoInnerPageKnownIds,
    doppeDtoInnerPageIsVerticalListType,
    DoppeDtoInnerPageType
} from '../types/doppe-dto-inner-page';
import {
    arrayDistinct,
    arrayFlatten,
    arrayRemoveNullishValues,
    evaluateFunction,
    immerProduce,
    iterableDistinct,
    iterableMapToArray,
    MemoizedValue,
    objectForEachValue,
    objectGetKeys,
    objectPick,
    objectRemoveEntries,
    objectShallowEqual,
    PerformanceMeasurer,
    performanceMeasuringScope,
    stringTrimPrefix,
    uuidCreate
} from '@wix/devzai-utils-common';
import {
    doppeHideableValueCreateHidden,
    doppeHideableValueGetValue,
    doppeHideableValueIsHidden,
    doppeHideableValueIsVisible
} from '../types/doppe-hideable-value';
import {DoppeHtmlSitePagesType} from '../types/doppe-html-site';
import {DoppeActionTypesMetadataStore} from '../doppe-action-types-metadata-store/doppe-action-types-metadata-store';
import {
    DoppeBymoTemplatesMetadataStore
} from '../doppe-bymo-templates-metadata-store/doppe-bymo-templates-metadata-store';
import {
    doppeActionIsLockActive,
    doppeActionIsOfType,
    doppeActionIsVisibleInPage,
    DoppeDtoAction,
    DoppeDtoActionSettingsMetadata,
    DoppeDtoActionViewType,
    doppeDtoActionViewTypeIsDisplayedAsButton,
    doppeDtoActionViewTypeIsPremium
} from '../types/doppe-dto-action';
import {
    doppeActionTypeSubscribeMetaData
} from '../../doppe-action-types/doppe-action-type-subscribe/doppe-action-type-subscribe-metadata';
import {BymoTemplatesIds} from '../doppe-templates/doppe-templates';
import {
    DoppePageNoneViolatedPremiumFeatures,
    DoppePagePremiumFeatures,
    doppePremiumFeatureGetLimit,
    doppePremiumFeatureIsEnabled,
    DoppePremiumFeatures,
    DoppePremiumFeaturesAlias,
    DoppePremiumFeaturesStatus
} from '../doppe-premium';
import {
    doppeActionButtonTemplateGetDefault,
    doppeActionButtonTemplateInstanceIsPremium
} from '../doppe-templates/doppe-action-button-template-utils';
import {
    doppeColorPaletteResolveCalculatedColorsData,
    doppePageFontFamilyIsPremium,
    doppePageFontGetDefaultFontFamily
} from '../../doppe-sdk';
import type {DoppeAppClientServices} from '../../client/doppe-app/doppe-app-client-services';
import {
    adjustListLayoutsToSize,
    bymoPageMediaResolveWixMediaResource,
    BymoPageNavigationMenuItemType,
    bymoPagePropsMigrationApply,
    BymoPagePropsMigrations,
    bymoPagePropsWasMigrationApplied,
    changeDefaultCheckoutSettingsForPaymentsActionsConverter,
    changeListActionListItems,
    changeViewTypeForNonePageActionsConverter,
    defaultActionMigrationConverter,
    iframeWidgetsAsPopupOpenerConverter,
    removeAllDeletedItems,
    setListActionsItemLayout,
    setListActionsMediaRatio,
    showActionsHeaderConverter
} from '../bymo-pages';
import {doppeActionTypeIframe} from '../../doppe-action-types/doppe-action-type-iframe/doppe-action-type-iframe';
import {doppeActionTypeCalendly} from '../../doppe-action-types/doppe-action-type-calendly/doppe-action-type-calendly';
import {
    DoppeActionListItemClickBehaviour,
    DoppeActionWidgetOpeningMode,
    DoppeListActionSettings,
    DoppeListActionSettingsContentSectionAutoValue,
    DoppeListActionSettingsCtaButtonAutoValue
} from '../types';
import {doppeActionTypeRequests} from '../../doppe-action-types/doppe-action-type-requests/doppe-action-type-requests';
import {doppeActionTypeRequest} from '../../doppe-action-types/doppe-action-type-request/doppe-action-type-request';
import {doppeActionTypeDonate} from '../../doppe-action-types/doppe-action-type-donate/doppe-action-type-donate';
import {
    doppeActionTypePaidMessage
} from '../../doppe-action-types/doppe-action-type-paid-message/doppe-action-type-paid-message';
import {doppeActionTypeBanner} from '../../doppe-action-types/doppe-action-type-banner/doppe-action-type-banner';
import {DoppeActionLockPreviewMode} from '../types/doppe-action-lock-preview-mode';
import {
    bymoPagePropsMigrationBlogPostActionsMediaSettingsApply
} from '../bymo-page-props-migrations/bymo-page-props-migration-blog-post-actions-media-settings/bymo-page-props-migration-blog-post-actions-media-settings';
import {
    bymoPagePropsMigrationCtaButtonsSettingsApply
} from '../bymo-page-props-migrations/bymo-page-props-migration-cta-buttons/bymo-page-props-migration-cta-buttons';
import {
    BymoPageMediaMaskingShape,
    bymoPageMediaMaskingShapeIsPremium
} from '../bymo-pages/bymo-page-media-masking-shape/bymo-page-media-masking-shape';
import {
    DoppeActionCTAButton,
    doppeActionCTAButtonFilterContentSettings,
    DoppeActionCTAButtonMultiple
} from '../types/doppe-action-cta-button';
import {
    DoppeActionContentSection,
    doppeActionContentSectionFilterContentSettings
} from '../types/doppe-action-content-section';
import {
    doppeActionTypeIsListAction,
    doppeActionTypeResolveContentSettingsOfTypes
} from '../doppe-action-types/doppe-action-type-utils';
import {
    BymoPagePropsContentSettingsFilterOptions,
    BymoPagePropsContentSettingType,
    bymoPagePropsResolveContentSettingsOfTypes,
} from '../bymo-page-props-metadata/bymo-page-props-metadata';
import {DoppeActionCtaButtonsSettings} from '../types/doppe-action-cta-buttons-settings';
import {BymoPageNavigationMenuItem} from '../bymo-pages/bymo-page-navigation-settings';
import {
    BymoTemplateSpeedDialSearchAppearance
} from '../../components/bymo-templates/bymo-template-speed-dial/bymo-template-speed-dial-common';
import {DoppeActionContentSectionsSettings} from "../types/doppe-action-content-sections-settings";
import {
    BymoTemplateSpeedDial
} from "../../components/bymo-templates/bymo-template-speed-dial/bymo-template-speed-dial.metadata";

export function bymoPageValidatePremiumFeatures(
    options: {
        bymoTemplateId: string;
        bymoPageProps: PartialBymoPageProps;
        premiumFeaturesStatus: DoppePremiumFeaturesStatus;
    }
) {
    const {
        bymoPageProps,
        premiumFeaturesStatus,
        bymoTemplateId
    } = options;

    const fullBymoPageProps = bymoPagePropsResolveFromPartialProps(bymoPageProps);

    const violatedPremiumFeatures = [] as DoppePagePremiumFeatures[];

    const updatedFullBymoPageProps = immerProduce(fullBymoPageProps, fullBymoPageProps => {
        const visibleActions = fullBymoPageProps.actions.filter(action => action.enabled);

        if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_verified_badge)) {
            if (fullBymoPageProps.showVerifiedCheck) {
                fullBymoPageProps.showVerifiedCheck = false;
                violatedPremiumFeatures.push(DoppePagePremiumFeatures.VerifiedBadge)
            }
        }

        if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_remove_banner)) {
            if (fullBymoPageProps.removeHoppBanner) {
                fullBymoPageProps.removeHoppBanner = false;
                violatedPremiumFeatures.push(DoppePagePremiumFeatures.RemoveBanner)
            }
        }

        if (bymoTemplateId === BymoTemplatesIds.SpeedDial) {
            if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_advanced_page_presets)) {
                if (bymoTemplateLayoutIsPremium(fullBymoPageProps.pageLayout.layout)) {

                    const latestNonPremiumPageLayout = fullBymoPageProps.latestNonPremiumValues.pageLayout?.layout;

                    fullBymoPageProps.pageLayout.layout =
                        latestNonPremiumPageLayout && !bymoTemplateLayoutIsPremium(latestNonPremiumPageLayout) ?
                            latestNonPremiumPageLayout :
                            bymoTemplateLayoutGetDefault();

                    violatedPremiumFeatures.push(DoppePagePremiumFeatures.ProLayout)
                }
            }
        }

        if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_advanced_design_options)) {
            if (doppeActionButtonTemplateInstanceIsPremium(fullBymoPageProps.actionButtonTemplate)) {
                fullBymoPageProps.actionButtonTemplate = fullBymoPageProps.latestNonPremiumValues.actionButtonTemplate ??
                    doppeActionButtonTemplateGetDefault();
                violatedPremiumFeatures.push(DoppePagePremiumFeatures.ProButtonStyle)
            }


            if (bymoPageMediaMaskingShapeIsPremium(fullBymoPageProps.profilePictureMaskingShape)) {
                fullBymoPageProps.profilePictureMaskingShape = BymoPageMediaMaskingShape.Circle;

                violatedPremiumFeatures.push(DoppePagePremiumFeatures.ProProfilePictureShape)
            }

            if (doppePageFontFamilyIsPremium(fullBymoPageProps.textFontFamily)) {
                fullBymoPageProps.textFontFamily = fullBymoPageProps.latestNonPremiumValues.textFontFamily ??
                    doppePageFontGetDefaultFontFamily(fullBymoPageProps.lang);

                violatedPremiumFeatures.push(DoppePagePremiumFeatures.ProFont)
            }
        }

        if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.creators_form_submission)) {
            for (const action of visibleActions) {

                if (doppeActionIsOfType(action, doppeActionTypeSubscribeMetaData) || doppeActionIsOfType(action, doppeActionTypeContactForm)) {
                    action.enabled = false;
                    violatedPremiumFeatures.push(DoppePagePremiumFeatures.FormActions)
                }
            }
        }

        if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeaturesAlias.bannerAction)) {
            for (const action of visibleActions) {

                if (doppeActionIsOfType(action, doppeActionTypeBanner)) {
                    action.enabled = false;
                    violatedPremiumFeatures.push(DoppePagePremiumFeatures.BannerAction)
                }
            }
        }

        if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.creators_monetization_actions)) {
            for (const action of visibleActions) {
                if (doppeActionIsOfType(action, doppeActionTypeRequests)
                    || doppeActionIsOfType(action, doppeActionTypeRequest)
                    || doppeActionIsOfType(action, doppeActionTypeDonate)
                    || doppeActionIsOfType(action, doppeActionTypePaidMessage))
                {
                    action.enabled = false;
                    violatedPremiumFeatures.push(DoppePagePremiumFeatures.PaymentActions)
                }
            }
        }

        if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_list_premium_styles)) {
            for (const action of visibleActions) {
                if (action.settings.layout) {
                    if (bymoTemplateListLayoutIsPremium(action.settings.layout)) {
                        const settings = action.settings;

                        settings.layout = settings.latestNonPremiumLayout && !bymoTemplateListLayoutIsPremium(settings.latestNonPremiumLayout) ?
                            settings.latestNonPremiumLayout :
                            bymoListLayoutGetDefault();

                        violatedPremiumFeatures.push(DoppePagePremiumFeatures.ProListLayout)
                    }
                }
            }
        }

        if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_latest_items_action)) {
            for (const action of visibleActions) {
                if (action.settings.externalDataSource) {
                    const settings = action.settings;

                    settings.externalDataSource = null;
                    violatedPremiumFeatures.push(DoppePagePremiumFeatures.LatestItemsInLists);
                }
            }
        }

        if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_lock_action)) {
            for (const action of visibleActions) {
                if (doppeActionIsLockActive(action)) {
                    action.lockSettings.enableLock = false;
                    violatedPremiumFeatures.push(DoppePagePremiumFeatures.LockSettings);
                }
            }
        }

        if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_contact_management)) {
            for (const action of visibleActions) {
                if (action.settings.listId) {
                    const settings = action.settings;

                    settings.listId = null;
                    violatedPremiumFeatures.push(DoppePagePremiumFeatures.ConnectToContactsList);
                }
            }
        }

        if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.creators_advanced_search_settings)) {
            for (const action of visibleActions) {
                if (doppeHideableValueIsVisible(action.searchSettings.title) || doppeHideableValueIsVisible(action.searchSettings.description) || doppeHideableValueIsVisible(action.searchSettings.image)) {
                    if (doppeHideableValueIsVisible(action.searchSettings.title)) {
                        action.searchSettings.title = doppeHideableValueCreateHidden(action.searchSettings.title);
                    }

                    if (doppeHideableValueIsVisible(action.searchSettings.description)) {
                        action.searchSettings.description = doppeHideableValueCreateHidden(action.searchSettings.description);
                    }

                    if (doppeHideableValueIsVisible(action.searchSettings.image)) {
                        action.searchSettings.image = doppeHideableValueCreateHidden(action.searchSettings.image);
                    }

                    violatedPremiumFeatures.push(DoppePagePremiumFeatures.AdvancedSearchSettings)
                }
            }

        }

        if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_advanced_design_options)) {
            for (const action of visibleActions) {
                if (doppeDtoActionViewTypeIsPremium(action.viewType)) {

                    switch (action.viewType) {
                        case DoppeDtoActionViewType.InPageFrameless: {
                            action.viewType = DoppeDtoActionViewType.InPage;
                            break;
                        }
                        case DoppeDtoActionViewType.BannerButton: {
                            action.viewType = DoppeDtoActionViewType.ActionButton;
                            break;
                        }
                    }

                    violatedPremiumFeatures.push(DoppePagePremiumFeatures.ProActionDisplay)
                }
            }
        }

        if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_full_screen_view)) {
            for (const action of visibleActions) {
                if (action.widgetOpeningMode === DoppeActionWidgetOpeningMode.Popup && doppeDtoActionViewTypeIsDisplayedAsButton(action.viewType) && (!doppeActionIsOfType(action, doppeActionTypeIframe) && !doppeActionIsOfType(action, doppeActionTypeCalendly))) {
                    action.widgetOpeningMode = DoppeActionWidgetOpeningMode.Inline;
                    violatedPremiumFeatures.push(DoppePagePremiumFeatures.ShowAsPopup)
                }

                if (action.settings.itemClickBehaviour === DoppeActionListItemClickBehaviour.PreviewItemAsPopup) {
                    action.settings.itemClickBehaviour = DoppeActionListItemClickBehaviour.PreviewItem;
                    violatedPremiumFeatures.push(DoppePagePremiumFeatures.ShowListItemAsPopup)
                }
            }
        }

    })

    if (violatedPremiumFeatures.length === 0) {
        return null;
    }

    return {
        modifiedBymoPageProps: updatedFullBymoPageProps,
        violatedPremiumFeatures: arrayDistinct(violatedPremiumFeatures)
    }
}

export function bymoPageValidateNoneViolatedPremiumFeatures(
    options: {
        clientServices: DoppeAppClientServices;
        bymoPageProps: PartialBymoPageProps;
        premiumFeaturesStatus: DoppePremiumFeaturesStatus;
    }
) {
    const {
        bymoPageProps,
        premiumFeaturesStatus,
        clientServices
    } = options;

    const fullBymoPageProps = bymoPagePropsResolveFromPartialProps(bymoPageProps);
    const visibleActions = fullBymoPageProps.actions.filter(doppeActionIsVisibleInPage);

    const noneViolatedPremiumFeatures = [] as DoppePageNoneViolatedPremiumFeatures[];

    const limit = doppePremiumFeatureGetLimit(premiumFeaturesStatus, DoppePremiumFeatures.hopp_add_items_to_list_action);

    if (limit !== Infinity) {
        for (const action of visibleActions) {
            const metaData = clientServices.doppeActionTypesClientService.getActionTypeClientMetadata(action.actionTypeId);

            if (metaData?.resolveListItemsCount && metaData?.resolveListItemsCount(action.settings) > limit) {
                noneViolatedPremiumFeatures.push(DoppePageNoneViolatedPremiumFeatures.ListItemsLimit)
            }
        }
    }

    if (noneViolatedPremiumFeatures.length === 0) {
        return null;
    }

    return arrayDistinct(noneViolatedPremiumFeatures)
}

export function bymoPageGetActionsWithPremiumFeatures(
    options: {
        clientServices: DoppeAppClientServices;
        bymoPageProps: PartialBymoPageProps;
        premiumFeaturesStatus: DoppePremiumFeaturesStatus;
    }
) {
    const {
        bymoPageProps,
        premiumFeaturesStatus,
        clientServices
    } = options;

    const fullBymoPageProps = bymoPagePropsResolveFromPartialProps(bymoPageProps);
    const visibleActions = fullBymoPageProps.actions.filter(doppeActionIsVisibleInPage);

    const limit = doppePremiumFeatureGetLimit(premiumFeaturesStatus, DoppePremiumFeatures.hopp_add_items_to_list_action);

    const actions = [];

    if (limit !== Infinity) {
        for (const action of visibleActions) {
            const metaData = clientServices.doppeActionTypesClientService.getActionTypeClientMetadata(action.actionTypeId);

            if (metaData?.resolveListItemsCount && metaData?.resolveListItemsCount(action.settings) > limit) {
                actions.push(action)
            }
        }
    }

    if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.creators_form_submission)) {
        for (const action of visibleActions) {

            if (doppeActionIsOfType(action, doppeActionTypeSubscribeMetaData) || doppeActionIsOfType(action, doppeActionTypeContactForm)) {
                actions.push(action);
            }
        }
    }

    if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_advanced_design_options)) {
        for (const action of visibleActions) {

            if (doppeDtoActionViewTypeIsPremium(action.viewType)) {
                actions.push(action);
            }
        }
    }

    if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.creators_monetization_actions)) {
        for (const action of visibleActions) {
            if (doppeActionIsOfType(action, doppeActionTypeRequests)
                || doppeActionIsOfType(action, doppeActionTypeRequest)
                || doppeActionIsOfType(action, doppeActionTypeDonate)
                || doppeActionIsOfType(action, doppeActionTypePaidMessage))
            {
                actions.push(action);
            }
        }
    }

    if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_list_premium_styles)) {
        for (const action of visibleActions) {
            if (action.settings.layout) {
                if (bymoTemplateListLayoutIsPremium(action.settings.layout)) {
                    actions.push(action);
                }
            }
        }
    }

    if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_latest_items_action)) {
        for (const action of visibleActions) {
            if (action.settings.externalDataSource) {
                actions.push(action);
            }
        }
    }

    if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_lock_action)) {
        for (const action of visibleActions) {
            if (doppeActionIsLockActive(action)) {
                actions.push(action);
            }
        }
    }

    if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_contact_management)) {
        for (const action of visibleActions) {
            if (action.settings.listId) {
                actions.push(action);
            }
        }
    }

    if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.creators_advanced_search_settings)) {
        for (const action of visibleActions) {
            if (doppeHideableValueIsVisible(action.searchSettings.title) || doppeHideableValueIsVisible(action.searchSettings.description) || doppeHideableValueIsVisible(action.searchSettings.image)) {
                actions.push(action);
            }
        }

    }

    if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_full_screen_view)) {
        for (const action of visibleActions) {
            if (action.widgetOpeningMode === DoppeActionWidgetOpeningMode.Popup && doppeDtoActionViewTypeIsDisplayedAsButton(action.viewType) && (!doppeActionIsOfType(action, doppeActionTypeIframe) && !doppeActionIsOfType(action, doppeActionTypeCalendly))) {
                actions.push(action);
            }

            if (action.settings.itemClickBehaviour === DoppeActionListItemClickBehaviour.PreviewItemAsPopup) {
                actions.push(action);            }
        }
    }


    if (actions.length === 0) {
        return null;
    }

    return arrayDistinct(actions)
}

export function bymoPageValidatePageTabPremiumFeatures(
    options: {
        bymoPageProps: PartialBymoPageProps;
        premiumFeaturesStatus: DoppePremiumFeaturesStatus;
    }
) {
    const {
        bymoPageProps,
        premiumFeaturesStatus,
    } = options;

    const fullBymoPageProps = bymoPagePropsResolveFromPartialProps(bymoPageProps);

    const violatedPremiumFeatures = [] as DoppePagePremiumFeatures[];

    if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_verified_badge)) {
        if (fullBymoPageProps.showVerifiedCheck) {
            violatedPremiumFeatures.push(DoppePagePremiumFeatures.VerifiedBadge)
        }
    }

    return arrayDistinct(violatedPremiumFeatures)
}

export function bymoPageValidateSettingsTabPremiumFeatures(
    options: {
        bymoPageProps: PartialBymoPageProps;
        premiumFeaturesStatus: DoppePremiumFeaturesStatus;
    }
) {
    const {
        bymoPageProps,
        premiumFeaturesStatus,
    } = options;

    const fullBymoPageProps = bymoPagePropsResolveFromPartialProps(bymoPageProps);

    const violatedPremiumFeatures = [] as DoppePagePremiumFeatures[];

    if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_seo_settings)) {
        if (fullBymoPageProps.seoSettings) {
            violatedPremiumFeatures.push(DoppePagePremiumFeatures.SeoSettings)
        }
    }

    if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_social_share_settings_editing)) {
        if (fullBymoPageProps.socialShareSettings) {
            violatedPremiumFeatures.push(DoppePagePremiumFeatures.SocialShare)
        }
    }

    if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_remove_banner)) {
        if (fullBymoPageProps.removeHoppBanner) {
            violatedPremiumFeatures.push(DoppePagePremiumFeatures.RemoveBanner)
        }
    }

    return arrayDistinct(violatedPremiumFeatures)
}

export function bymoPageValidateDesignTabPremiumFeatures(
    options: {
        bymoTemplateId: string;
        bymoPageProps: PartialBymoPageProps;
        premiumFeaturesStatus: DoppePremiumFeaturesStatus;
    }
) {
    const {
        bymoPageProps,
        premiumFeaturesStatus,
        bymoTemplateId
    } = options;

    const fullBymoPageProps = bymoPagePropsResolveFromPartialProps(bymoPageProps);

    const violatedPremiumFeatures = [] as DoppePagePremiumFeatures[];

    if (bymoTemplateId === BymoTemplatesIds.SpeedDial) {
        if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_advanced_page_presets)) {
            if (bymoTemplateLayoutIsPremium(fullBymoPageProps.pageLayout.layout)) {
                violatedPremiumFeatures.push(DoppePagePremiumFeatures.ProLayout)
            }
        }
    }

    if (!doppePremiumFeatureIsEnabled(premiumFeaturesStatus, DoppePremiumFeatures.hopp_advanced_design_options)) {
        if (doppeActionButtonTemplateInstanceIsPremium(fullBymoPageProps.actionButtonTemplate)) {
            violatedPremiumFeatures.push(DoppePagePremiumFeatures.ProButtonStyle)
        }

        if (doppePageFontFamilyIsPremium(fullBymoPageProps.textFontFamily)) {
            violatedPremiumFeatures.push(DoppePagePremiumFeatures.ProFont)
        }
    }

    return arrayDistinct(violatedPremiumFeatures)
}

export function bymoPagePropsRemoveViolatedPremiumFeatures (
    options: {
        premiumFeaturesStatus: DoppePremiumFeaturesStatus | null;
        bymoTemplateId: string;
        partialBymoPageProps: PartialBymoPageProps;
    }
) {
    const {
        premiumFeaturesStatus,
        bymoTemplateId,
        partialBymoPageProps,
    } = options;

    if (premiumFeaturesStatus) {
        const bymoPageValidationResult = bymoPageValidatePremiumFeatures({
            bymoTemplateId: bymoTemplateId,
            bymoPageProps: partialBymoPageProps,
            premiumFeaturesStatus: premiumFeaturesStatus
        });

        return bymoPageValidationResult?.modifiedBymoPageProps ?? partialBymoPageProps;
    } else {
        return partialBymoPageProps;
    }
}

export function bymoPagePropsEnsureMigratedToLatestSchema(
    options: {
        bymoTemplateId: string;
        bymoPageProps: PartialBymoPageProps | BymoPageProps;
        actionTypesStore: DoppeActionTypesMetadataStore;
        bymoTemplatesMetadataStore: DoppeBymoTemplatesMetadataStore;
    }
) {
    const {
        bymoTemplateId,
        bymoPageProps: partialBymoPageProps,
        actionTypesStore,
        bymoTemplatesMetadataStore,
    } = options;

    const bymoPageProps = bymoPagePropsResolveFromPartialProps(
        partialBymoPageProps,
        bymoTemplatesMetadataStore.assertBymoPageTemplateMetadata(bymoTemplateId)
    )

    return immerProduce(bymoPageProps, pageSettings => {
        // this is change of schema migration there for it should run before the default values migration
        if (!bymoPagePropsWasMigrationApplied(bymoPageProps, BymoPagePropsMigrations.MigrateListActionsListItems)) {
            pageSettings.actions = iterableMapToArray(pageSettings.actions, (action, skip) => {
                const convertedAction = executeMigrationForAction({
                    action,
                    actionTypesStore,
                    migrationCallback: changeListActionListItems
                })

                return convertedAction ?? skip;
            })

            pageSettings.appliedMigrations.push({
                migration: BymoPagePropsMigrations.MigrateListActionsListItems,
                metadata: {}
            })
        }


        // this is change of schema migration there for it should run before the default values migration
        if (!bymoPagePropsWasMigrationApplied(bymoPageProps, BymoPagePropsMigrations.MigrateCheckoutSettingsStructure)) {
            pageSettings.actions = iterableMapToArray(pageSettings.actions, (action, skip) => {
                const convertedAction = executeMigrationForAction({
                    action,
                    actionTypesStore,
                    migrationCallback: changeDefaultCheckoutSettingsForPaymentsActionsConverter
                })

                return convertedAction ?? skip;
            })

            pageSettings.appliedMigrations.push({
                migration: BymoPagePropsMigrations.MigrateCheckoutSettingsStructure,
                metadata: {}
            })
        }

        bymoPagePropsMigrationBlogPostActionsMediaSettingsApply({
            pageSettings: pageSettings,
            actionTypesStore: actionTypesStore
        })

        bymoPagePropsMigrationApply({
            migration: BymoPagePropsMigrations.DefaultProfilePictureShape,
            pageSettings: pageSettings,
            migrationFunction: pageSettings => {
                if (pageSettings.pageLayout.layout === BymoTemplateLayout.Layout7) {
                    pageSettings.profilePictureMaskingShape = BymoPageMediaMaskingShape.Square
                }
            }
        });


        // default migration for all action props and settings should run first
        pageSettings.actions = iterableMapToArray(pageSettings.actions, (action, skip) => {

            const convertedAction = executeMigrationForAction({
                action,
                actionTypesStore,
                migrationCallback: defaultActionMigrationConverter
            })

            return convertedAction ?? skip;
        })

        if (bymoTemplateId === BymoTemplatesIds.Basic && !bymoPagePropsWasMigrationApplied(bymoPageProps, BymoPagePropsMigrations.BasicToSpeedDialConversion)) {

            const basicTemplatePageSettings = pageSettings as BymoPageProps<BymoTemplateSpeedDial.TemplateProps>;
            basicTemplatePageSettings.profilePictureLinkInBio = basicTemplatePageSettings.profilePicture;
            basicTemplatePageSettings.profilePicture = null;

            basicTemplatePageSettings.pageLayout = {
                layout: BymoTemplateLayout.Standard
            }

            basicTemplatePageSettings.pageTitle = basicTemplatePageSettings.headingText;
            basicTemplatePageSettings.actionsHeading = basicTemplatePageSettings.callToActionText;
            basicTemplatePageSettings.searchAppearance = BymoTemplateSpeedDialSearchAppearance.Hidden;
            basicTemplatePageSettings.showActionsInSearch = false;

            basicTemplatePageSettings.appliedMigrations.push({
                migration: BymoPagePropsMigrations.BasicToSpeedDialConversion,
                metadata: {}
            })
        }

        if (!bymoPagePropsWasMigrationApplied(bymoPageProps, BymoPagePropsMigrations.ChangeViewTypeForNonePageActions)) {
            pageSettings.actions = iterableMapToArray(pageSettings.actions, (action, skip) => {
                const convertedAction = executeMigrationForAction({
                    action,
                    actionTypesStore,
                    migrationCallback: changeViewTypeForNonePageActionsConverter
                })

                return convertedAction ?? skip;
            })

            pageSettings.appliedMigrations.push({
                migration: BymoPagePropsMigrations.ChangeViewTypeForNonePageActions,
                metadata: {}
            })
        }



        if (!bymoPagePropsWasMigrationApplied(bymoPageProps, BymoPagePropsMigrations.IframeWidgetsAsPopupOpener)) {
            pageSettings.actions = iterableMapToArray(pageSettings.actions, (action, skip) => {
                const convertedAction = executeMigrationForAction({
                    action,
                    actionTypesStore,
                    migrationCallback: iframeWidgetsAsPopupOpenerConverter
                })

                return convertedAction ?? skip;
            })

            pageSettings.appliedMigrations.push({
                migration: BymoPagePropsMigrations.IframeWidgetsAsPopupOpener,
                metadata: {}
            })
        }

        if (!bymoPagePropsWasMigrationApplied(bymoPageProps, BymoPagePropsMigrations.ShowActionHeaderForAllViewTypes)) {
            pageSettings.actions = iterableMapToArray(pageSettings.actions, (action, skip) => {
                const convertedAction = executeMigrationForAction({
                    action,
                    actionTypesStore,
                    migrationCallback: showActionsHeaderConverter
                })

                return convertedAction ?? skip;
            })

            pageSettings.appliedMigrations.push({
                migration: BymoPagePropsMigrations.ShowActionHeaderForAllViewTypes,
                metadata: {}
            })
        }

        if (!bymoPagePropsWasMigrationApplied(bymoPageProps, BymoPagePropsMigrations.RemoveDeletedListActionsListItems)) {
            pageSettings.actions = iterableMapToArray(pageSettings.actions, (action, skip) => {
                const convertedAction = executeMigrationForAction({
                    action,
                    actionTypesStore,
                    migrationCallback: removeAllDeletedItems
                })

                return convertedAction ?? skip;
            })

            pageSettings.appliedMigrations.push({
                migration: BymoPagePropsMigrations.RemoveDeletedListActionsListItems,
                metadata: {}
            })
        }

        if (!bymoPagePropsWasMigrationApplied(bymoPageProps, BymoPagePropsMigrations.AdjustListLayoutMediaRatio)) {
            pageSettings.actions = iterableMapToArray(pageSettings.actions, (action, skip) => {
                const convertedAction = executeMigrationForAction({
                    action,
                    actionTypesStore,
                    migrationCallback: setListActionsMediaRatio
                })

                return convertedAction ?? skip;
            })

            pageSettings.appliedMigrations.push({
                migration: BymoPagePropsMigrations.AdjustListLayoutMediaRatio,
                metadata: {}
            })
        }

        if (!bymoPagePropsWasMigrationApplied(bymoPageProps, BymoPagePropsMigrations.AdjustListLayoutMediaSize)) {
            pageSettings.actions = iterableMapToArray(pageSettings.actions, (action, skip) => {
                const convertedAction = executeMigrationForAction({
                    action,
                    actionTypesStore,
                    migrationCallback: adjustListLayoutsToSize
                })

                return convertedAction ?? skip;
            })

            pageSettings.appliedMigrations.push({
                migration: BymoPagePropsMigrations.AdjustListLayoutMediaSize,
                metadata: {}
            });
        }

        if (!bymoPagePropsWasMigrationApplied(bymoPageProps, BymoPagePropsMigrations.AdjustListItemLayout)) {
            pageSettings.actions = iterableMapToArray(pageSettings.actions, (action, skip) => {
                const convertedAction = executeMigrationForAction({
                    action,
                    actionTypesStore,
                    migrationCallback: setListActionsItemLayout
                })

                return convertedAction ?? skip;
            })

            pageSettings.appliedMigrations.push({
                migration: BymoPagePropsMigrations.AdjustListItemLayout,
                metadata: {}
            })
        }



        bymoPagePropsMigrationCtaButtonsSettingsApply({
            pageSettings: pageSettings,
            actionTypesStore: actionTypesStore
        })

    })
}

function executeMigrationForAction(params: {
    action: DoppeDtoAction<any>,
    actionTypesStore: DoppeActionTypesMetadataStore,
    migrationCallback: (action: DoppeDtoAction<any>, actionTypesStore: DoppeActionTypesMetadataStore) => DoppeDtoAction<any> | undefined
}) : DoppeDtoAction<any> | undefined {

    const {
        action,
        actionTypesStore,
        migrationCallback
    } = params;

    const convertedAction =  migrationCallback(action, actionTypesStore);

    if (convertedAction && convertedAction.lockSettings.lockActions.length > 0) {
        convertedAction.lockSettings.lockActions =
            iterableMapToArray(convertedAction.lockSettings.lockActions, (lockedAction, skip) => {
                const convertedLockedAction =  migrationCallback(lockedAction, actionTypesStore);
                return convertedLockedAction ?? skip;
            });

    }

    return convertedAction;
}

export async function bymoPageProcessPropsForViewer(
    options: {
        bymoTemplateId: string;
        bymoPageProps: PartialBymoPageProps;
        actionTypesStore: DoppeActionTypesMetadataStore;
        bymoTemplatesMetadataStore: DoppeBymoTemplatesMetadataStore;
        omitLockedActionsSettings: boolean;
        performanceMeasurer?: PerformanceMeasurer
    }
): Promise<BymoPagePropsForViewer> {

    const {
        bymoPageProps,
        bymoTemplatesMetadataStore,
        bymoTemplateId,
        actionTypesStore,
        omitLockedActionsSettings,
        performanceMeasurer
    } = options;

    return performanceMeasuringScope(performanceMeasurer, `bymoPageProcessPropsForViewer`, async () => {
        const migratedBymoPageProps = bymoPagePropsEnsureMigratedToLatestSchema({
            bymoPageProps: bymoPageProps,
            bymoTemplatesMetadataStore: bymoTemplatesMetadataStore,
            bymoTemplateId: bymoTemplateId,
            actionTypesStore: actionTypesStore,
        })

        return {
            ...immerProduce(migratedBymoPageProps, bymoPageProps => {
                // ✅ Process all page actions (main page + inner pages)
                const pageActions = bymoPagePropsResolvePageActions(bymoPageProps);
                
                for (const action of pageActions) {
                    const actionType = actionTypesStore.getActionTypeMetadataByActionTypeId(action.actionTypeId);

                    const isLocked = doppeActionIsLockActive(action);
                    const isCustomLockPreview = action.lockSettings.lockPreviewMode === DoppeActionLockPreviewMode.Custom;

                    if (isCustomLockPreview && omitLockedActionsSettings && isLocked) {
                        // action.settings = {};
                        // action.settings = actionType?.resolveActionSettings?.({});
                    } else {
                        actionType?.prepareForViewer?.(action.settings, {
                            isLocked: isLocked,
                            isInnerCtaLocked: !isCustomLockPreview,
                            omitLockedActionsSettings: omitLockedActionsSettings
                        });
                    }

                    // Process locked actions for this action
                    for (const lockedAction of action.lockSettings.lockActions) {
                        const actionType = actionTypesStore.getActionTypeMetadataByActionTypeId(lockedAction.actionTypeId);
                        actionType?.prepareForViewer?.(lockedAction.settings, {
                            isLocked: false,
                            isInnerCtaLocked: false,
                            omitLockedActionsSettings: omitLockedActionsSettings
                        });
                    }
                }
            }),
            __forViewer: true as const,
            colorPaletteCalculatedColorsData: await doppeColorPaletteResolveCalculatedColorsData(migratedBymoPageProps.colorPalette)
        };
    })
}

export function bymoPageResolveUsedMedia(
    options: {
        bymoTemplateId: string;
        bymoPageProps: PartialBymoPageProps;
        actionTypesStore: DoppeActionTypesMetadataStore;
        performanceMeasurer?: PerformanceMeasurer;
    }
) {
    const {
        bymoPageProps,
        actionTypesStore,
        performanceMeasurer
    } = options;

    return performanceMeasuringScope(performanceMeasurer, `bymoPageResolveUsedMedia`, () => {
        const fullBymoPageProps = bymoPagePropsResolveFromPartialProps(bymoPageProps);
        const allActions = bymoPagePropsResolveAllActions(fullBymoPageProps);

        const mediaUsedInActions = arrayFlatten(iterableMapToArray(allActions, action => {
            const actionType = actionTypesStore.getActionTypeMetadataByActionTypeId(action.actionTypeId);

            return arrayRemoveNullishValues([
                ...(actionType?.resolveUsedMedia?.(action.settings) ?? []).map(bymoPageMediaResolveWixMediaResource),
                doppeHideableValueGetValue(action.icon),
                action.bannerMedia,
                doppeHideableValueGetValue(action.searchSettings.image),
                action.lockSettings.customLockPreviewMedia,
            ]);
        }));

        const allUsedMedia = [
            ...mediaUsedInActions
        ];

        const usedMediaUrlsSet = new Set<string>();

        return iterableMapToArray(allUsedMedia, (usedMedia, skip) => {

            // TODO: Handle video
            const mediaUrl = wixMediaResourceIsWixImageResource(usedMedia) ?
                wixImageResourceGetUrl(usedMedia) :
                undefined;

            if (mediaUrl && !usedMediaUrlsSet.has(mediaUrl)) {
                return usedMedia;
            } else {
                return skip;
            }
        })
    })
}

export function bymoPageResolvePropsWithReplacedExternalImages(
    options: {
        bymoTemplateId: string;
        bymoPageProps: PartialBymoPageProps;
        actionTypesStore: DoppeActionTypesMetadataStore;
        externalImagesUrlToImageResourceMap: Map<string, WixImageResource>;
    }
) {

    const {
        bymoPageProps,
        actionTypesStore,
        externalImagesUrlToImageResourceMap
    } = options;

    const fullBymoPageProps = bymoPagePropsResolveFromPartialProps(bymoPageProps);

    return {
        ...fullBymoPageProps,
        actions: fullBymoPageProps.actions.map(action => {
            const actionType = actionTypesStore.getActionTypeMetadataByActionTypeId(action.actionTypeId);

            if (actionType && actionType.replaceExternalImages) {

                const actionSettings = actionType.resolveActionSettings(action);

                return {
                    ...action,
                    settings: actionType.replaceExternalImages(actionSettings, externalImagesUrlToImageResourceMap)
                }
            }

            return action;
        })
    }
}

export function bymoPageResolveUsedBusinessEntities(
    options: {
        bymoTemplateId: string;
        bymoPageProps: BymoPageProps;
        actionTypesStore: DoppeActionTypesMetadataStore;
        bymoTemplatesMetadataStore: DoppeBymoTemplatesMetadataStore;
    }
) {
    const {
        bymoPageProps,
        actionTypesStore,
        bymoTemplatesMetadataStore,
        bymoTemplateId
    } = options;


    const fullBymoPageProps = bymoPagePropsResolveFromPartialProps(
        bymoPageProps,
        bymoTemplatesMetadataStore.assertBymoPageTemplateMetadata(bymoTemplateId)
    );

    // Get all actions from main page and inner pages
    const allActions = bymoPagePropsResolveAllActions(fullBymoPageProps);

    const businessEntitiesReferences = arrayFlatten(iterableMapToArray(allActions, (action, skip) => {

        if (!doppeActionIsVisibleInPage(action)) {
            return skip;
        }

        const actionType = actionTypesStore.getActionTypeMetadataByActionTypeId(action.actionTypeId);

        if (actionType && actionType.resolveUsedBusinessEntities) {

            const actionSettings = actionType.resolveActionSettings(action);

            return actionType.resolveUsedBusinessEntities(actionSettings)
        }

        return skip;
    }));

    return iterableDistinct(businessEntitiesReferences, businessEntityReference => JSON.stringify([businessEntityReference.businessEntity, businessEntityReference.id]))
}

export function bymoPageResolveUsedBusinessEntitiesCreateMemoizedValue() {
    return new MemoizedValue<
        Parameters<typeof bymoPageResolveUsedBusinessEntities>[0],
        ReturnType<typeof bymoPageResolveUsedBusinessEntities>
    >({
        valueFunction: value => bymoPageResolveUsedBusinessEntities(value),
        hasChanged: (prevValue, newValue) => {
            // Check if main page actions changed
            if (prevValue.bymoPageProps.actions !== newValue.bymoPageProps.actions) {
                return true;
            }
            
            // Check if inner pages changed (for pages with inner pages feature)
            const prevInnerPages = (prevValue.bymoPageProps as any).innerPages;
            const newInnerPages = (newValue.bymoPageProps as any).innerPages;
            
            if (prevInnerPages !== newInnerPages) {
                return true;
            }
            
            return false;
        }
    })
}

export function bymoPageCreateMemoizedValueForPropsForViewerProcessing(
    options: {
        logValueCalculation?: boolean;
    } = {}
) {
    const {
        logValueCalculation = false
    } = options;


    return new MemoizedValue<
        Parameters<typeof bymoPageProcessPropsForViewer>[0],
        ReturnType<typeof bymoPageProcessPropsForViewer>
    >({
        valueFunction: value => {
            if (logValueCalculation) {
                console.log(`Calculating PropsForViewer`)
            }

            return bymoPageProcessPropsForViewer(value);
        },
        hasChanged: (prevValue, newValue) => {
            return !objectShallowEqual(prevValue, newValue);
        }
    })
}

export function bymoPageDuplicateAction<T extends {}>(
    options: {
        bymoPageProps: BymoPageProps;
        action: DoppeDtoAction<T>;
        duplicatedNamePrefix?: string;
    }
) {
    const {
        action,
        duplicatedNamePrefix = ''
    } = options;

    const duplicateAction = (actionToDuplicate: DoppeDtoAction) => {
        const tempAction = {
            ...JSON.parse(JSON.stringify(actionToDuplicate)),
            name: `${duplicatedNamePrefix}${stringTrimPrefix(actionToDuplicate.name, duplicatedNamePrefix)}`,
            id: uuidCreate(),
        } satisfies DoppeDtoAction;

        if (tempAction.lockSettings.lockActions.length > 0) {
            tempAction.lockSettings.lockActions = (tempAction.lockSettings as DoppeDtoAction.LockSettings).lockActions.map((lockAction) => {
                return duplicateAction(lockAction);
            });
        }

        if (tempAction.settings.ctaButtons ) {
            tempAction.settings.ctaButtons = (tempAction.settings.ctaButtons as DoppeActionCTAButtonMultiple[]).map((ctaButton) => {
                return {
                    ...ctaButton,
                    id: uuidCreate(),
                }
            })
        }

        if (tempAction.settings.listItemTemplateCtaButtonsSettings?.ctaButtons) {
            const buttonsIdsMap = new Map<string, string>();
            const buttons = tempAction.settings.listItemTemplateCtaButtonsSettings?.ctaButtons as DoppeActionCTAButton.MultipleButton[]
            tempAction.settings.listItemTemplateCtaButtonsSettings.ctaButtons = buttons.map((ctaButton) => {
                const newId = uuidCreate();
                buttonsIdsMap.set(ctaButton.id, newId);
                return {
                    ...ctaButton,
                    id: newId,
                }
            })

            const listDataItems = tempAction.settings.listDataItems as DoppeListActionSettings.ListItemWithCtaButtons[];

            if (listDataItems) {
                listDataItems.forEach((listDataItem) => {
                    if (listDataItem.customCtaButtons) {
                        listDataItem.customCtaButtons = listDataItem.customCtaButtons.map((customCtaButton) => {
                            if (customCtaButton !== DoppeListActionSettingsCtaButtonAutoValue.ListTemplateButtons) {
                                const newId = uuidCreate();
                                buttonsIdsMap.set(customCtaButton.id, newId);
                                return {
                                    ...customCtaButton,
                                    id: newId,
                                }
                            }
                            else {
                                return customCtaButton;
                            }
                        })
                    }

                    if (listDataItem.ctaButtonsOverridesMap) {
                        listDataItem.ctaButtonsOverridesMap = evaluateFunction(() => {
                            const newCtaButtonsOverridesMap : typeof listDataItem.ctaButtonsOverridesMap = {}
                            objectForEachValue(listDataItem.ctaButtonsOverridesMap,(ctaButtonOverride ,id) => {
                                const newId = buttonsIdsMap.get(id);
                                if (newId) {
                                    newCtaButtonsOverridesMap[newId] = ctaButtonOverride;
                                }
                            });

                            return newCtaButtonsOverridesMap;
                        })
                    }

                });
            }
        }

        if (tempAction.settings.listItemTemplateSectionsSettings?.sections) {
            const sectionsIdsMap = new Map<string, string>();
            const sections = tempAction.settings.listItemTemplateSectionsSettings?.sections as DoppeActionContentSection[]
            tempAction.settings.listItemTemplateSectionsSettings.sections = sections.map((section) => {
                const newId = uuidCreate();
                sectionsIdsMap.set(section.id, newId);
                return {
                    ...section,
                    id: newId,
                }
            })

            const listDataItems = tempAction.settings.listDataItems as DoppeListActionSettings.ListItemWithSections[];

            if (listDataItems) {
                listDataItems.forEach((listDataItem) => {
                    if (listDataItem.customSections) {
                        listDataItem.customSections = listDataItem.customSections.map((customSection) => {
                            if (customSection !== DoppeListActionSettingsContentSectionAutoValue.ListTemplateSections) {
                                const newId = uuidCreate();
                                sectionsIdsMap.set(customSection.id, newId);
                                return {
                                    ...customSection,
                                    id: newId,
                                }
                            }
                            else {
                                return customSection;
                            }
                        })
                    }


                    if (listDataItem.sectionsOverridesMap) {
                        listDataItem.sectionsOverridesMap = evaluateFunction(() => {
                            const newSectionsOverridesMap : typeof listDataItem.sectionsOverridesMap = {}
                            objectForEachValue(listDataItem.sectionsOverridesMap,(sectionOverride ,id) => {
                                const newId = sectionsIdsMap.get(id);
                                if (newId) {
                                    newSectionsOverridesMap[newId] = sectionOverride;
                                }
                            });

                            return newSectionsOverridesMap;
                        })
                    }
                });
            }
        }

        return tempAction;
    }

    return duplicateAction(action) as DoppeDtoAction<T>
}

export function bymoPagePropsReduceToContentSettings (
    options: {
        bymoPageProps: BymoPageProps;
        bymoTemplateId: string;
        actionTypesStore: DoppeActionTypesMetadataStore;
        bymoTemplatesMetadataStore: DoppeBymoTemplatesMetadataStore;
        settingTypes: BymoPagePropsContentSettingType[];
        visibleOnly: boolean;
    }
) {
    const {
        bymoPageProps,
        actionTypesStore,
        settingTypes,
        bymoTemplatesMetadataStore,
        bymoTemplateId,
        visibleOnly
    } = options;

    const applySettingsFilter = <T extends {}>(settings: T) => {
        if (visibleOnly) {
            return objectRemoveEntries(settings, value => {
                return doppeHideableValueIsHidden(value);
            })
        } else {
            return settings;
        }
    }

    const bymoTemplateMetadata = bymoTemplatesMetadataStore.getBymoPageTemplateMetadata(bymoTemplateId);

    const contentSettingsFilterOptions: BymoPagePropsContentSettingsFilterOptions = {
        settingTypes: settingTypes,
        visibleOnly: visibleOnly
    }

    return {
        ...applySettingsFilter(
            objectPick(
                bymoPageProps,
                objectGetKeys(bymoPagePropsResolveContentSettingsOfTypes(BymoPagePropsCommonPropsMetadata, settingTypes))
            )
        ),
        ...applySettingsFilter(
            objectPick(
                bymoPageProps,
                bymoTemplateMetadata ? objectGetKeys(bymoPagePropsResolveContentSettingsOfTypes(bymoTemplateMetadata.templatePropsMetadata, settingTypes)) : []
            )
        ),
        actions: iterableMapToArray(bymoPageProps.actions, (action, skip) => {
            const actionType = actionTypesStore.getActionTypeMetadataByActionTypeId(action.actionTypeId);

            if (actionType) {

                return {
                    ...applySettingsFilter(objectPick(action, objectGetKeys(bymoPagePropsResolveContentSettingsOfTypes(DoppeDtoActionSettingsMetadata, settingTypes)))),
                    settings: {
                        ...applySettingsFilter(objectPick(
                            action.settings,
                            objectGetKeys(doppeActionTypeResolveContentSettingsOfTypes(
                                actionType.actionSettingsMetadata.contentSettingsMetadata,
                                settingTypes
                            ))
                        )),
                        ...evaluateFunction(() => {
                            if (actionType.actionSettingsMetadata.supportsActionCtaButtons) {
                                return {
                                    ctaButtons: (action.settings as DoppeActionCtaButtonsSettings).ctaButtons.map(ctaButton => {
                                        return doppeActionCTAButtonFilterContentSettings(ctaButton, contentSettingsFilterOptions)
                                    })
                                }
                            } else {
                                return undefined;
                            }
                        }),
                        ...evaluateFunction(() => {
                            if (actionType.actionSettingsMetadata.supportsContentSections) {
                                return {
                                    sections: (action.settings as DoppeActionContentSectionsSettings).sections.map(section => {
                                        return doppeActionContentSectionFilterContentSettings(section, contentSettingsFilterOptions)
                                    })
                                }
                            } else {
                                return undefined;
                            }
                        }),
                        ...evaluateFunction(() => {
                            if (doppeActionTypeIsListAction(actionType)) {
                                return {
                                    listDataItems: (action.settings as DoppeListActionSettings<any>).listDataItems.map(listDataItem => applySettingsFilter(objectPick(
                                        listDataItem,
                                        objectGetKeys(doppeActionTypeResolveContentSettingsOfTypes(
                                            actionType.actionListItemSettingsMetadata.contentSettingsMetadata,
                                            settingTypes
                                        ))
                                    ))),
                                }
                            } else {
                                return {};
                            }
                        })
                    }
                }
            }

            return skip;
        })
    }
}

// ============================================================================
// URL-Based Page Resolution
// ============================================================================

// ============================================================================
// Migration Utilities
// ============================================================================

/**
 * Checks if a page is a vertical page by looking up its data in innerPages
 */
export function bymoPageIsVerticalPage(
    pageId: string,
    bymoPageProps: BymoPageProps<any>
): boolean {
    if (pageId === DoppeDtoInnerPageKnownIds.Home) {
        return false;
    }

    const page = bymoPageGetInnerVerticalPages(bymoPageProps)
        .find(p => p.id === pageId);
    return !!page?.type && doppeDtoInnerPageIsVerticalListType(page.type);
}

/**
 * Derives the vertical page type from a WixTpaAppId
 */
export function bymoPageGetVerticalPageTypeFromAppId(verticalPageType: DoppeDtoInnerPageType): DoppeHtmlSitePagesType | null {
    switch (verticalPageType) {
        case DoppeDtoInnerPageType.Products:
            return DoppeHtmlSitePagesType.Store;
        case DoppeDtoInnerPageType.BlogPosts:
            return DoppeHtmlSitePagesType.Blog;
        case DoppeDtoInnerPageType.Events:
            return DoppeHtmlSitePagesType.Events;
        case DoppeDtoInnerPageType.Bookings:
            return DoppeHtmlSitePagesType.BookingServices;
        default:
            return null;
    }
}

/**
 * Gets a page by ID from innerPages (includes both content pages and vertical pages)
 */
export function bymoPageGetInnerNavigatablePageById(
    pageId: DoppeDtoInnerPage.Id,
    bymoPageProps: BymoPageProps<any>
): DoppeDtoInnerPage | null {
    return bymoPageGetInnerNavigatablePages(bymoPageProps).find(p => p.id === pageId) || null;
}

/**
 * Gets all pages for navigation in the correct order based on navigationSettings.menuItems
 * This is the main function that should be used by navigation components
 * Only returns page-type menu items that are visible, filtered and with resolved titles
 */
export function bymoPageGetInnerNavigatablePages(
    bymoPageProps: BymoPageProps
): DoppeDtoInnerPage[] {
    return [...bymoPageProps.innerPages, ...bymoPageGetInnerVerticalPages(bymoPageProps)];
}

/**
 * Gets all pages for navigation in the correct order based on navigationSettings.menuItems
 * This is the main function that should be used by navigation components
 * Only returns page-type menu items that are visible, filtered and with resolved titles
 */
export function bymoPageGetInnerContentPages(
    bymoPageProps: BymoPageProps
): DoppeDtoInnerPage[] {
    return bymoPageProps.innerPages;
}

/**
 * Gets all pages for navigation in the correct order based on navigationSettings.menuItems
 * This is the main function that should be used by navigation components
 * Only returns page-type menu items that are visible, filtered and with resolved titles
 */
export function bymoPageGetInnerVerticalPages(
    bymoPageProps: BymoPageProps
): DoppeDtoInnerPage[] {
    return [bymoPageProps.defaultBlogPostsPage, bymoPageProps.defaultStoreProductsPage, bymoPageProps.defaultEventsPage, bymoPageProps.defaultBookingsPage];
}

export function bymoPageGetInnerVerticalItemPages(
    bymoPageProps: BymoPageProps
): DoppeDtoInnerPage[] {
    return [bymoPageProps.defaultProductPage];
}

export function bymoPageGetBlogPages(
    bymoPageProps: BymoPageProps
): DoppeDtoInnerPage[] {
    return [
        bymoPageProps.defaultBlogPostsPage
    ];
}

export function bymoPageGetStorePages(
    bymoPageProps: BymoPageProps
): DoppeDtoInnerPage[] {
    return [
        bymoPageProps.defaultStoreProductsPage,
        bymoPageProps.defaultProductPage
    ];
}


export function bymoPageGetEventsPages(
    bymoPageProps: BymoPageProps
): DoppeDtoInnerPage[] {
    return [
        bymoPageProps.defaultEventsPage
    ];
}

export function bymoPageGetBookingsPages(
    bymoPageProps: BymoPageProps
): DoppeDtoInnerPage[] {
    return [
        bymoPageProps.defaultBookingsPage
    ];
}

/**
 * Gets all visible menu items (both pages and links) in the correct order
 * This function can be used by navigation components that support external links
 */
export function bymoPageGetNavigationMenuItems(
    bymoPageProps: BymoPageProps
): BymoPageNavigationMenuItem[] {
    // Get effective menu items (supports both new and legacy structures)
    const menuItems = bymoPageProps.navigationSettings.menuItems;
    const innerContentPages = bymoPageGetInnerContentPages(bymoPageProps);

    // Filter for visible items and validate that page-type items exist
    return menuItems.filter(menuItem => {
        if (!menuItem.isVisible) {
            return false;
        }

        // If it's a page-type menu item, verify the page exists
        if (menuItem.settings.type === BymoPageNavigationMenuItemType.Page) {
            const pageId = menuItem.settings.pageId;
            
            // Home page always exists
            if (pageId === DoppeDtoInnerPageKnownIds.Home) {
                return true;
            }
            
            // Check if the inner page exists
            return innerContentPages.some(page => page.id === pageId);
        }

        // Link-type menu items are always included if visible
        return true;
    });
}

/**
 * Gets all navigation items (both pages and links) formatted for navigation components.
 * Returns a consistent array of navigation menu items that can be used by navigation UI components.
 */
export function bymoPageGetAllNavigationItems(
    bymoPageProps: BymoPageProps
): BymoPageNavigationMenuItem[] {
    const menuItems = bymoPageGetNavigationMenuItems(bymoPageProps);
    const items: BymoPageNavigationMenuItem[] = [];

    const innerPages = bymoPageGetInnerNavigatablePages(bymoPageProps);

    // Process menu items in order, including both pages and links
    for (const menuItem of menuItems) {
        // Skip if not visible
        if (!menuItem.isVisible) {
            continue;
        }

        if (menuItem.settings.type === BymoPageNavigationMenuItemType.Page) {
            // Handle page items - validate that the page exists
            const pageSettings = menuItem.settings;
            const pageId = pageSettings.pageId;

            if (pageId === DoppeDtoInnerPageKnownIds.Home) {
                // Home page always exists
                items.push(menuItem);
            } else {
                // Verify the inner page exists before including it
                const innerPage = innerPages.find(page => page.id === pageId);
                if (innerPage) {
                    items.push(menuItem);
                }
            }
        } else if (menuItem.settings.type === BymoPageNavigationMenuItemType.Link) {
            items.push(menuItem);
        }
    }

    return items;
}

/**
 * Creates a page-type navigation menu item
 */
export function bymoPageCreatePageMenuItem(options: {
    title: string;
    pageId: string;
    isVisible?: boolean;
}): BymoPageNavigationMenuItem {
    const { title, pageId, isVisible = true } = options;

    return {
        id: uuidCreate(),
        title: title,
        isVisible: isVisible,
        settings: {
            type: BymoPageNavigationMenuItemType.Page,
            pageId: pageId
        }
    };
}

/**
 * Creates a link-type navigation menu item
 */
export function bymoPageCreateLinkMenuItem(options: {
    title: string;
    url: string;
    openInNewTab?: boolean;
    isVisible?: boolean;
}): BymoPageNavigationMenuItem {
    const { title, url, openInNewTab = false, isVisible = true } = options;

    return {
        id: uuidCreate(),
        title: title,
        isVisible: isVisible,
        settings: {
            type: BymoPageNavigationMenuItemType.Link,
            url: url,
            openInNewTab: openInNewTab
        }
    };
}

